import { Spinner } from '@rewardops/ui'

import { useItems } from '~/components/hooks/use-items'
import ItemCard from '~/components/maple/item-card'
import { SortOptionType, SortOrder } from '~/app/common/enums'
import { PAWSectionType } from './paw-section-types'

export const RewardsCatalog: React.FC<PAWSectionType> = ({
  content,
  data,
}: PAWSectionType) => {
  const { loading, items } = useItems(
    {
      isFeatured: true,
      sort: { by: SortOptionType.CreatedDate, order: SortOrder.Descending },
    },
    1,
    12,
  )

  return (
    <section id={content?.sectionId} data-testid={content?.sectionId}>
      <h2 className="mb-6 text-xl font-semibold">
        {content?.title ?? 'Rewards Catalog'}
      </h2>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {loading ? <Spinner /> : null}
        {items?.map((item: any, index: number) => (
          <ItemCard key={item?.id} item={item} position={index} />
        ))}
      </div>
    </section>
  )
}
